<template>
    <div class="home" v-if="hasAccessToModule">

        <div v-if="isLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h2>Door Inspections</h2>
                    </div>
                    <div class="widget-body border-bottom">
                        <router-link to="/door-checks/add"
                                     class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3"
                                     style="display:block;width:100%">Start New Door Inspection
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3 class="d-none">
                            Incomplete Surveys ({{ incompleteDoorChecks.length }})</h3>
                        <h3 id="no-incomplete-surveys">
                            Incomplete Surveys ({{ filteredCount }})</h3>
                    </div>
                    <div class="widget-body">
                        <div class="input-group pb-5">
                            <span class="input-group-addon pr-0 pl-0">
                                <a class="btn" href="#">
                                    <i class="fa fa-search"></i>
                                </a>
                            </span>
                            <input type="text" class="form-control dynamic-search" name="search_term"
                                   v-model="search"
                                   placeholder="Search (enter at least 3 characters)">
                        </div>


                        <div class="container">

                            <incomplete-survey
                                    v-for="doorCheck in filteredDoorChecks"
                                    v-bind:key="doorCheck.id"
                                    v-bind:doorCheck="doorCheck"
                                    v-bind:doorCheckDoors="doorCheckDoors"
                            ></incomplete-survey>

                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import IncompleteSurvey from '@/components/IncompleteSurvey.vue'

    export default {
        data() {
            return {
                retryIncompleteDoorChecksCount: 0,
                retryGetDoorCheckDoorsCount: 0,
                isLoading: true,
                hasAccessToModule: true,
                search: '',
                incompleteDoorChecks: [],
                doorCheckDoors: [],
            }
        },
        name: 'home',
        components: {
            IncompleteSurvey,
        },
        computed: {
            filteredDoorChecks() {
                if (this.incompleteDoorChecks.length > 0) {
                    return this.incompleteDoorChecks.filter(doorCheck => {
                        return (doorCheck.document_id && doorCheck.document_id.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                            || (doorCheck.document_title && doorCheck.document_title.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                    });
                } else {
                    return [];
                }
            },
            filteredCount() {
                return this.filteredDoorChecks.length;
            }
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(modulesData && modulesData.indexOf('FDR') > -1) {
                this.hasAccessToModule = true;
                this.getIncompleteDoorChecks();
                this.getDoorCheckDoors();
            } else {
                this.hasAccessToModule = false;
                this.isLoading = false;
            }
        },
        methods: {
            getIncompleteDoorChecks() {

                var vmt = this;
                this.getDb(function onConnected(db) {
                    var vm = vmt;
                    vm.incompleteDoorChecks = [];
                    try {
                        var objectStore = db.transaction('door_checks').objectStore('door_checks');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                vm.isLoading = false;
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.incompleteDoorChecks) {
                                        if (
                                            (cursor.value.is_deleted === undefined || cursor.value.is_deleted === false) &&
                                            (cursor.value.is_complete === undefined || cursor.value.is_complete === false)
                                        ) {
                                            vm.incompleteDoorChecks.push(cursor.value)
                                        }
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                    }
                });
            },
            getDoorCheckDoors() {
                var vmt = this;
                this.getDb(function onConnected(db) {
                    var vm = vmt;
                    vm.doorCheckDoors = [];
                    try {
                        var objectStore = db.transaction('door_check_doors').objectStore('door_check_doors');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.doorCheckDoors) {
                                        vm.doorCheckDoors.push(cursor.value);
                                    }
                                    cursor.continue();
                                }
                            }
                        }
                    } catch (e) {
                    }
                });
            },
        }
    }
</script>
